import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Productos from './Productos';
import './App.css';
import Navbar from './componentes/Navbar';
import Footer from './componentes/Footer';
import Magazine from './Magazine';
import PreNavbar from './componentes/Pre-navbar';


function App() {
  return (
    <Router>
      <PreNavbar/>
      <Navbar/>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/magazine" element={<Magazine />} /> 
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;